// 这个变量中注册带单位的style字段
export const STYLE_FIELDS = ['marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'height', 'width', 'borderWidth', 'borderRadius', 'borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius', 'fontSize'];
export const WIDTH_MAX = 2000;
export const HEIGHT_MAX = 2000;
export const COLOR_PICKER_INIT_VALUE = '#00000000';
export const specicalCssValuePattern = /auto|\d+\.?(%|vw|vh|vmin|vmax|r?em)|{{/;
//# sourceMappingURL=constant.js.map
